import Vue from 'vue'
import commonMutations from '@/store/data/common/mutations'
import { parseData, unParseData } from './helpers'
import { keyBy } from 'lodash'

const mutations = {
    ...commonMutations,

    /**
     * Add DB existing points in batch to savedPoints state
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points that have been saved
     */
    addPoints(state, { points }) {
        Vue.set(state, 'savedPoints', [...state.savedPoints, ...parseData(points)])
    },

    /**
     * Add new points in batch to unSavedPoints state
     * With property action set to 'create'
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points that have been saved
     */
    addNewPoints(state, { points }) {
        const newPoints = points.map(p => ({
            ...p,
            action: p.action || 'create'
        }))
        Vue.set(state, 'unSavedPoints', [...state.unSavedPoints, ...newPoints])
    },

    /**
     * Initialize savedPoints and unSavedPoints state
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points that have been saved
     */
    initializePoints(state, { points }) {
        points = points.filter(p => p.status !== 'deleted')
        Vue.set(state, 'savedPoints', parseData(points))
        Vue.set(state, 'unSavedPoints', points)
    },

    /**
     * Set an existing point
     * And set property action to 'update' if the property was not already set
     * @param {Object} state - Vuex state
     * @param {Object} payload
     * @param {Number} payload.index index of the points in the source array
     * @param {Object} payload.value new value of the point
     */
    setPoint(state, { index, value }) {
        const point = {
            ...value,
            action: value.action === 'noAction' ? null : value.action || 'update'
        }
        Vue.set(state.unSavedPoints, index, point)
    },

    /**
     * Set existing points in batch
     * In the same way of setPoint mutation
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points
     */
    setPoints(state, { points }) {
        points.forEach(value => {
            const index = state.unSavedPoints.findIndex(p => p.id == value.id)
            const point = {
                ...value,
                action: value.action || 'update'
            }
            if (index >= 0) Vue.set(state.unSavedPoints, index, point)
        })
    },

    /**
     * Initialize savedPoints and unSavedPoints state
     * @param {Object} state - Vuex state
     */
    syncPoints(state) {
        Vue.set(state, 'unSavedPoints', unParseData(state.savedPoints))
    },

    /**
     * Update savedPoints in batch
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points that have been updated
     */
    updatePoints(state, { points }) {
        parseData(points).forEach(point => {
            const index = state.savedPoints.findIndex(p => p.id == point.id)
            if (index >= 0) Vue.set(state.savedPoints, index, point)
        })
    },

    /**
     *
     * @param {Object} state - Vuex state
     * @param {Number} index
     */
    deleteUnsavedPoint(state, index) {
        state.unSavedPoints.splice(index, 1)
    },

    /**
     * Delete savedPoints in batch
     * @param {Object}      state - Vuex state
     * @param {Object}      payload
     * @param {Object[]}    payload.points array of points to delete
     */
    deletePoints(state, { points }) {
        points.forEach(point => {
            const index = state.savedPoints.findIndex(p => p.id == point.id)
            if (index >= 0) state.savedPoints.splice(index, 1)
        })
    },

    /**
     *
     * @param {Object} state - Vuex state
     * @param {Boolean} value
     */
    setCheckIsLoading(state, value) {
        Vue.set(state, 'checkIsLoading', value)
    },

    /**
     *
     * @param {Object} state - Vuex state
     * @param {Boolean} value
     */
    setRetrievePointsLoading(state, value) {
        Vue.set(state, 'retrievePointsLoading', value)
        if (!value) state.retrievePointsCount += 1
    },

    setCollection(state, data) {
        Vue.set(state, 'collection', keyBy(data, 'crossId'))
    },

    setGeoradarInCollection(state, georadar) {
        Vue.set(state.collection, georadar.crossId, georadar)
    },

    removeAudienceInCollection(state, id) {
        Vue.delete(state.collection, id)
    }
}
export default mutations
